module.exports = __webpack_public_path__ + "img/Branches.c1376be4.svg";